// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__H_Cuu","paramInput":"JobSimulator_paramInput__2Vx21","input":"JobSimulator_input__2dn4y"};